/**
 * カート追加機能
 */

// Vercel Draft Order API エンドポイント
function getDraftOrderApiUrl() {
  // theme.liquidで設定済み（localhost検出含む）
  const baseUrl = window.API_BASE_URL;
  return `${baseUrl}/api/create-draft-order`;
}

/**
 * 分納指定データをproperties形式に変換
 * @param {Object} optionProperties - プロパティオブジェクト
 * @param {string} splitDeliveryJson - 分納データJSON文字列
 * @param {string} optionLabel - オプションラベル
 */
function processSplitDeliveryForProperties(optionProperties, splitDeliveryJson, optionLabel) {
  try {
    const splitData = typeof splitDeliveryJson === 'string' 
      ? JSON.parse(splitDeliveryJson) 
      : splitDeliveryJson;
    
    if (!splitData || !splitData.destinations || splitData.destinations.length === 0) {
      return;
    }
    
    // サマリ情報
    optionProperties['【分納指定】'] = `${splitData.destination_count}件に分納（+${splitData.additional_fee.toLocaleString()}円）`;
    optionProperties['_split_delivery_enabled'] = 'true';
    optionProperties['_split_delivery_count'] = String(splitData.destination_count);
    optionProperties['_split_delivery_fee'] = String(splitData.additional_fee);
    optionProperties['_split_delivery_total_quantity'] = String(splitData.total_quantity);
    
    // 各配送先の情報
    splitData.destinations.forEach((dest, idx) => {
      const num = idx + 1;
      const prefix = `【分納先${num}】`;
      
      // 発送数量
      optionProperties[`${prefix}数量`] = `${dest.quantity}部`;
      
      // 発送先情報
      if (dest.company_name) {
        optionProperties[`${prefix}企業名`] = `${dest.company_name} 様`;
      }
      optionProperties[`${prefix}宛名`] = `${dest.recipient_name} 様`;
      optionProperties[`${prefix}フリガナ`] = `${dest.recipient_kana} 様`;
      optionProperties[`${prefix}郵便番号`] = dest.zip;
      
      // 住所をまとめて表示
      let fullAddress = `${dest.prefecture}${dest.city_address}`;
      if (dest.building) {
        fullAddress += ` ${dest.building}`;
      }
      optionProperties[`${prefix}住所`] = fullAddress;
      optionProperties[`${prefix}電話番号`] = dest.phone;
      
      // 荷主情報
      if (dest.use_orderer_as_sender) {
        optionProperties[`${prefix}荷主`] = '注文者情報と同じ';
      } else {
        optionProperties[`${prefix}荷主名`] = `${dest.sender_name} 様`;
        
        let senderAddress = `${dest.sender_prefecture}${dest.sender_address}`;
        if (dest.sender_building) {
          senderAddress += ` ${dest.sender_building}`;
        }
        optionProperties[`${prefix}荷主住所`] = senderAddress;
        optionProperties[`${prefix}荷主電話`] = dest.sender_phone;
        
        if (dest.sender_zip) {
          optionProperties[`${prefix}荷主郵便番号`] = dest.sender_zip;
        }
      }
      
      // 備考
      if (dest.note) {
        optionProperties[`${prefix}備考`] = dest.note;
      }
    });
    
    // 内部用にJSON全体も保存（プログラム処理用）
    optionProperties['_split_delivery_json'] = JSON.stringify(splitData);
    
    
  } catch (e) {
    console.error('[Cart] 分納指定データの処理エラー:', e);
  }
}

/**
 * カート追加前に分納指定のバリデーションを行う
 * @param {number} orderQuantity - 注文数量
 * @returns {Object} { valid: boolean, message: string }
 */
function validateSplitDeliveryBeforeCart(orderQuantity) {
  if (!window.groupedOptionsManager) {
    return { valid: true, message: '' };
  }
  
  // 分納指定オプションを探す
  let splitDeliveryOptionId = null;
  let splitDeliverySelection = null;
  
  window.groupedOptionsManager.selectedOptions.forEach((selection, optionId) => {
    // 分納指定オプションを特定（split_deliveryまたはadditionalFieldsにsplit_delivery_dataがある場合）
    if (selection.additionalFieldValues && selection.additionalFieldValues.split_delivery_data) {
      splitDeliveryOptionId = optionId;
      splitDeliverySelection = selection;
    }
  });
  
  // 分納指定がない場合は問題なし
  if (!splitDeliveryOptionId || !splitDeliverySelection) {
    return { valid: true, message: '' };
  }
  
  try {
    const splitDataJson = splitDeliverySelection.additionalFieldValues.split_delivery_data;
    const splitData = typeof splitDataJson === 'string' ? JSON.parse(splitDataJson) : splitDataJson;
    
    if (!splitData || !splitData.destinations || splitData.destinations.length === 0) {
      return { 
        valid: false, 
        message: '分納指定を選択していますが、配送先情報が入力されていません。\n「任意オプション」から分納先情報を入力してください。' 
      };
    }
    
    // 数量の合計チェック
    const totalSplitQuantity = splitData.destinations.reduce((sum, d) => sum + (d.quantity || 0), 0);
    
    if (totalSplitQuantity !== orderQuantity) {
      return { 
        valid: false, 
        message: `分納先の数量合計（${totalSplitQuantity.toLocaleString()}部）が注文数量（${orderQuantity.toLocaleString()}部）と一致しません。\n\n「任意オプション」から分納先の数量を修正してください。` 
      };
    }
    
    // 必須項目チェック
    const missingFields = [];
    splitData.destinations.forEach((dest, idx) => {
      const num = idx + 1;
      if (!dest.recipient_name) missingFields.push(`配送先${num}: お名前`);
      if (!dest.recipient_kana) missingFields.push(`配送先${num}: フリガナ`);
      if (!dest.zip) missingFields.push(`配送先${num}: 郵便番号`);
      if (!dest.prefecture) missingFields.push(`配送先${num}: 都道府県`);
      if (!dest.city_address) missingFields.push(`配送先${num}: 市区町村番地`);
      if (!dest.phone) missingFields.push(`配送先${num}: 電話番号`);
      if (!dest.quantity || dest.quantity <= 0) missingFields.push(`配送先${num}: 発送数量`);
    });
    
    if (missingFields.length > 0) {
      return { 
        valid: false, 
        message: `分納先の必須項目が入力されていません。\n\n【未入力項目】\n${missingFields.join('\n')}\n\n「任意オプション」から入力してください。` 
      };
    }
    
    return { valid: true, message: '' };
    
  } catch (e) {
    console.error('[Cart] 分納バリデーションエラー:', e);
    return { valid: false, message: '分納データの確認中にエラーが発生しました。' };
  }
}

/**
 * GroupedOptionsManagerから分納データを取得してpropertiesに変換
 * @param {Object} optionProperties - プロパティオブジェクト
 */
function collectSplitDeliveryFromGroupedOptions(optionProperties) {
  if (!window.groupedOptionsManager) return;
  
  window.groupedOptionsManager.selectedOptions.forEach((selection, optionId) => {
    if (selection.additionalFieldValues && selection.additionalFieldValues.split_delivery_data) {
      processSplitDeliveryForProperties(optionProperties, selection.additionalFieldValues.split_delivery_data, '分納指定');
    }
  });
}

// 現在のバリエーションIDを取得
function getCurrentVariantId(paper, printColor, variants) {
  const variant = variants.find(v => 
    v.option1 === paper && v.option2 === printColor
  );
  
  if (variant) {
    return variant.id;
  }
  
  return variants[0].id;
}

// すべてのフォーム送信をログに記録（デバッグ用）
document.addEventListener('submit', function(e) {
}, true);

// 隠されたフォームの送信を防止
document.addEventListener('DOMContentLoaded', function() {
  const addToCartForm = document.getElementById('AddToCartForm');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  }
});

// ブラウザのbfcache復帰時にカートボタンを復元
// （Draft Order作成中にリダイレクト → ブラウザバックで戻った場合にボタンがdisabledのままになる対策）
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    var pcBtn = document.getElementById('add-to-cart-btn');
    var mobileBtn = document.getElementById('mobile-add-to-cart');
    if (pcBtn && pcBtn.disabled) {
      pcBtn.disabled = false;
      pcBtn.textContent = '🛒 カートに追加';
    }
    if (mobileBtn && mobileBtn.disabled) {
      mobileBtn.disabled = false;
      mobileBtn.textContent = '🛒 カートに追加';
    }
  }
});

// カートに追加（Draft Order経由）
document.addEventListener('DOMContentLoaded', function() {
  const addToCartBtn = document.getElementById('add-to-cart-btn');
  const mobileAddToCartBtn = document.getElementById('mobile-add-to-cart');
  
  // カート追加処理を共通化
  const handleAddToCart = async function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (!window.priceCalculator) {
      alert('価格計算器の初期化中です。少しお待ちください。');
      return;
    }

    // オプション読み込み中のバリデーション
    if (window._optionsLoading) {
      alert('オプションを読み込み中です。少しお待ちください。');
      return;
    }

    // 必須オプションのバリデーション
    if (window.optionsManager && window.optionsManager.hasOptions) {
      
      const validation = window.optionsManager.validateRequiredOptions();
      if (!validation.isValid) {
        alert(validation.message);
        return;
      }
    }
    
  
    const result = window.priceCalculator.calculatePrice();
    const selection = window.priceCalculator.currentSelection;
    
    if (!result || result.total === 0) {
      alert('価格が計算できません。選択内容を確認してください。');
      return;
    }
    
    // ★ 分納指定のバリデーション（ポイントモーダルの前に確認）
    if (window.groupedOptionsManager) {
      const splitDeliveryValidation = validateSplitDeliveryBeforeCart(selection.quantity);
      if (!splitDeliveryValidation.valid) {
        alert(splitDeliveryValidation.message);
        return;
      }
    }

    const proceedToCheckoutFlow = function() {
      // ★ ポイントモーダル表示（ログイン済みの場合）
      if (window.customerData && window.customerData.id && typeof window.showPointConfirmationModal === 'function') {
        window.showPointConfirmationModal({
          totalPrice: result.subtotal,
          result: result,
          selection: selection
        });
        return;
      }

      // ★ 未ログインまたはポイントモーダルがない場合、そのままDraft Order作成
      createDraftOrder(result, selection, 0);
    };

    // ★ 商品タイトル入力モーダル（カート追加直前）
    if (window.productCustomTitle && typeof window.productCustomTitle.prompt === 'function') {
      window.productCustomTitle.prompt()
        .then(function() {
          proceedToCheckoutFlow();
        })
        .catch(function() {
          // キャンセル時は何もしない
        });
      return;
    }

    proceedToCheckoutFlow();
  };
  
  // PC版カートボタン
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', handleAddToCart);
  } else {
    console.error('[Cart] PC版カートボタンが見つかりません (ID: add-to-cart-btn)');
  }
  
  // モバイル版カートボタン
  if (mobileAddToCartBtn) {
    mobileAddToCartBtn.addEventListener('click', handleAddToCart);
  } else {
    console.warn('[Cart] モバイル版カートボタンが見つかりません (ID: mobile-add-to-cart)');
  }
});

// ★ ポイント確定後のコールバック関数
window.confirmOrderWithPoints = function(pointsToUse) {
  
  const result = window.priceCalculator.calculatePrice();
  const selection = window.priceCalculator.currentSelection;
  
  createDraftOrder(result, selection, pointsToUse);
};

// Draft Order作成関数
async function createDraftOrder(result, selection, pointsToUse = 0) {
  const addToCartBtn = document.getElementById('add-to-cart-btn');
  const mobileAddToCartBtn = document.getElementById('mobile-add-to-cart');
  
  // ボタンを無効化してダブルクリックを防止
  if (addToCartBtn) {
    addToCartBtn.disabled = true;
    addToCartBtn.textContent = '処理中...';
  }
  if (mobileAddToCartBtn) {
    mobileAddToCartBtn.disabled = true;
    mobileAddToCartBtn.textContent = '処理中...';
  }
  
  try {
    // オプション情報を収集（必須/任意のセクション区切り付き）
    const optionProperties = {};
    let hasRequiredOptions = false;
    let hasOptionalOptions = false;

    if (window.optionsManager && window.optionsManager.hasOptions) {
      // 必須オプションがあるか確認
      const requiredEntries = Object.entries(window.optionsManager.selectedOptions.required).filter(([_, choice]) => choice);
      const optionalEntries = Object.entries(window.optionsManager.selectedOptions.optional).filter(([_, choice]) => choice);

      hasRequiredOptions = requiredEntries.length > 0;
      hasOptionalOptions = optionalEntries.length > 0;

      // 必須オプション
      if (hasRequiredOptions) {
        optionProperties['_section_required'] = '━━━━━━━━━━';
      }
      requiredEntries.forEach(([optionId, choice]) => {
        if (choice) {
          const option = window.optionsManager.optionsById[optionId];
          let label = choice.label;

          // カスタムサイズ情報を含める
          if (choice.customSize) {
            label += ` (${choice.customSize.width}mm × ${choice.customSize.height}mm)`;
          }

          optionProperties[option.label] = label;

          // ★ 追加入力フィールドを追加（納品代行など）
          if (choice.additionalFields && typeof choice.additionalFields === 'object') {
            Object.entries(choice.additionalFields).forEach(([fieldId, fieldValue]) => {
              if (fieldValue && String(fieldValue).trim() !== '') {
                // 分納指定データの場合は特別処理
                if (fieldId === 'split_delivery_data') {
                  processSplitDeliveryForProperties(optionProperties, fieldValue, option.label);
                } else {
                  // オプション定義から追加フィールドのラベルを取得
                  const fieldDef = option.additionalFields?.find(f => f.id === fieldId);
                  const fieldLabel = fieldDef ? fieldDef.label : fieldId;
                  optionProperties[`${option.label}_${fieldLabel}`] = fieldValue;
                }
              }
            });
          }
        }
      });

      // 任意オプション
      if (hasOptionalOptions) {
        optionProperties['_section_optional'] = '━━━━━━━━━━';
      }
      optionalEntries.forEach(([optionId, choice]) => {
        if (choice) {
          const option = window.optionsManager.optionsById[optionId];
          let label = choice.label;

          // カスタムサイズ情報を含める
          if (choice.customSize) {
            label += ` (${choice.customSize.width}mm × ${choice.customSize.height}mm)`;
          }

          optionProperties[option.label] = label;

          // ★ 追加入力フィールドを追加（納品代行など）
          if (choice.additionalFields && typeof choice.additionalFields === 'object') {
            Object.entries(choice.additionalFields).forEach(([fieldId, fieldValue]) => {
              if (fieldValue && String(fieldValue).trim() !== '') {
                // 分納指定データの場合は特別処理
                if (fieldId === 'split_delivery_data') {
                  processSplitDeliveryForProperties(optionProperties, fieldValue, option.label);
                } else {
                  // オプション定義から追加フィールドのラベルを取得
                  const fieldDef = option.additionalFields?.find(f => f.id === fieldId);
                  const fieldLabel = fieldDef ? fieldDef.label : fieldId;
                  optionProperties[`${option.label}_${fieldLabel}`] = fieldValue;
                }
              }
            });
          }
        }
      });
    }
    
    // ★ GroupedOptionsManagerから分納データを取得
    collectSplitDeliveryFromGroupedOptions(optionProperties);
    
    // ★ オプションの追加料金を収集（別ライン項目用）
    const optionFees = [];
    if (window.productOptionsManager) {
      const requiredOptions = window.productOptionsManager.selectedOptions.required || {};
      const optionalOptions = window.productOptionsManager.selectedOptions.optional || {};
      
      // 全オプションをチェック
      [...Object.entries(requiredOptions), ...Object.entries(optionalOptions)].forEach(([optionId, choice]) => {
        if (!choice || !choice.price_modifier) return;
        
        const option = window.productOptionsManager.optionsById[optionId];
        if (!option) return;
        
        let fee = 0;
        let label = option.label;
        
        // 価格修正タイプに応じた計算
        if (typeof choice.price_modifier === 'number') {
          fee = choice.price_modifier;
        } else if (typeof choice.price_modifier === 'object') {
          if (choice.price_modifier.type === 'fixed') {
            fee = choice.price_modifier.value || 0;
          } else if (choice.price_modifier.type === 'per_unit') {
            fee = (choice.price_modifier.value || 0) * selection.quantity;
          } else if (choice.price_modifier.type === 'percentage') {
            // パーセンテージの場合は商品価格から計算
            fee = Math.round(result.basePrice * (choice.price_modifier.value || 0) / 100);
          }
        }
        
        // 分納以外で料金がある場合のみ追加
        if (fee > 0 && !option.label.includes('分納')) {
          optionFees.push({
            label: label,
            value: choice.label || '',
            fee: fee
          });
        }
      });
    }
    
    // オプション料金情報をpropertiesに追加
    if (optionFees.length > 0) {
      optionProperties['_option_fees_json'] = JSON.stringify(optionFees);
    }
    
    // ★ ポイント使用情報を追加
    if (pointsToUse > 0) {
      optionProperties['_ポイント使用'] = `${pointsToUse}pt`;
      optionProperties['_ポイント割引額'] = `¥${pointsToUse.toLocaleString()}`;
    }
    
    // 現在のバリエーションIDを取得
    const variantId = getCurrentVariantId(
      selection.paper, 
      selection.printColor,
      window.productData.variants
    );
    
    // ★ 分納追加料金を取得（Draft Order APIで別ライン項目として追加するため、商品価格からは除外）
    let splitDeliveryFee = 0;
    if (optionProperties['_split_delivery_enabled'] === 'true' && optionProperties['_split_delivery_fee']) {
      splitDeliveryFee = parseInt(optionProperties['_split_delivery_fee']) || 0;
    }
    
    // ★ オプション追加料金の合計を計算
    const totalOptionFees = optionFees.reduce((sum, opt) => sum + opt.fee, 0);
    
    // ★ ポイント割引を適用した価格（分納追加料金とオプション料金は除外、Draft Order APIで別ライン項目として追加）
    const productPrice = result.subtotal - splitDeliveryFee - totalOptionFees;
    const finalPrice = productPrice - pointsToUse;
    
    
    // ★ ページ範囲と実際のページ数を取得（冊子商品用）
    const pageRange = window.currentProductInfo?.pageRange || null;  // "8-28P" 等
    // ページ数: selectionから取得、なければデフォルト値を使用
    let pageCount = selection.pageCount || null;
    if (!pageCount && window.pageCountOptions?.options?.length > 0) {
      // デフォルトページ数を取得
      const defaultPageCount = window.pageCountOptions.default || window.pageCountOptions.options[0];
      if (defaultPageCount) {
        const numMatch = String(defaultPageCount).match(/(\d+)/);
        pageCount = numMatch ? parseInt(numMatch[1]) : null;
      }
    }

    // ★ 印刷色数を取得
    // 優先順位: 1. selection.printColor（ページ範囲パターンは除外） 2. ColorTypeSelector 3. タイトルから抽出
    let printColorForOrder = selection.printColor;

    // 冊子商品でページ範囲がprintColorに入っている場合は除外
    // パターン: 8-28P, 12-28P, 32-48P 等
    if (printColorForOrder && /^\d+-\d+P$/i.test(printColorForOrder)) {
      console.log('[Cart] printColor contains page range pattern, ignoring:', printColorForOrder);
      printColorForOrder = null;
    }

    // ColorTypeSelectorから色タイプ情報を取得（通常商品用）
    let colorTypeSummary = null;
    if (window.ColorTypeSelector && typeof window.ColorTypeSelector.getSelection === 'function') {
      const colorSel = window.ColorTypeSelector.getSelection();
      if (colorSel.front || colorSel.back) {
        const parts = [];
        if (colorSel.front) parts.push(`表面 ${colorSel.front.name}`);
        if (colorSel.back) parts.push(`裏面 ${colorSel.back.name}`);
        colorTypeSummary = parts.join(' / ');
      }
    }

    // 冊子商品の印刷色数を商品タイトルから抽出
    if (!printColorForOrder && window.currentProductInfo?.title) {
      const title = window.currentProductInfo.title;
      // 無線綴じパターン: （表紙カラー／本文カラー）（表紙4C／本文1C）等
      const perfectMatch = title.match(/（(表紙(?:カラー|モノクロ|4C)／本文(?:カラー|モノクロ|[14]C))）/);
      if (perfectMatch) {
        printColorForOrder = perfectMatch[1];
      } else {
        // 中綴じパターン: フルカラー / モノクロ
        const saddleMatch = title.match(/(フルカラー|モノクロ)/);
        if (saddleMatch) {
          printColorForOrder = saddleMatch[1];
        } else {
          // 汎用パターン: 括弧内に「カラー」「モノクロ」「4C」「1C」を含む場合
          const genericMatch = title.match(/（([^）]*(?:カラー|モノクロ|4C|1C)[^）]*)）/);
          if (genericMatch) {
            printColorForOrder = genericMatch[1];
          }
        }
      }
    }

    // ★ 再注文用に商品ハンドルを保存
    if (window.productData && window.productData.handle) {
      optionProperties['_product_handle'] = window.productData.handle;
    }

    // ★ 顧客入力の商品タイトル（必須）
    if (window.productCustomTitle) {
      const customTitle = window.productCustomTitle.getValue();
      if (customTitle) {
        optionProperties[window.productCustomTitle.key] = customTitle;
      }
    }
    
    // ★ 発送予定日を計算して保存（マイページ表示用）
    let estimatedShippingDate = '';
    if (window.businessDayCalculator && window.businessDayCalculator.loaded) {
      try {
        const deliveryResult = window.businessDayCalculator.calculateDeliveryDate(selection.delivery, 0);
        if (deliveryResult && deliveryResult.date) {
          const dateObj = deliveryResult.date;
          estimatedShippingDate = `${dateObj.getFullYear()}/${String(dateObj.getMonth() + 1).padStart(2, '0')}/${String(dateObj.getDate()).padStart(2, '0')}`;
          optionProperties['発送予定日'] = estimatedShippingDate;
        }
      } catch (e) {
        console.warn('[Cart] 発送予定日の計算に失敗:', e);
      }
    }

    // 色タイプ情報を追加
    if (window.ColorTypeSelector && typeof window.ColorTypeSelector.getCartProperties === 'function') {
      const colorTypeProps = window.ColorTypeSelector.getCartProperties();
      if (colorTypeProps) {
        Object.assign(optionProperties, colorTypeProps);
      }
    }

    // ★ 商品情報を取得（updateGoodsHeaderと同じロジック）
    const productTitle = window.currentProductInfo?.title || '商品';
    const productGroupInfo = window.productGroupInfo;
    const priceCalcSelection = window.priceCalculator?.currentSelection || {};

    // 印刷方法の決定
    // 1. 部数に応じた印刷方式（print_type_config設定がある場合）を優先
    // 2. productGroupInfoを確認
    // 3. なければタイトルから抽出
    let printMethod = null;

    // 部数に応じた印刷方式をチェック
    const hasPrintTypeConfig = !!window.productData?.print_type_config;
    if (hasPrintTypeConfig && selection.quantity) {
      if (window.getPrintTypeForQuantity) {
        const allPriceData = window.productData?.price_matrix?.price_data || [];
        printMethod = window.getPrintTypeForQuantity(allPriceData, selection.quantity);
      } else if (window.determinePrintTypeByQuantity) {
        printMethod = window.determinePrintTypeByQuantity(selection.quantity, window.productData.print_type_config);
      }
    }

    // 部数ベースの印刷方式がない場合はproductGroupInfoを確認
    if (!printMethod) {
      printMethod = productGroupInfo?.currentPrintType || null;
    }

    // それでもない場合はタイトルから抽出
    if (!printMethod) {
      if (/オフセット/.test(productTitle)) {
        printMethod = 'オフセット';
      } else if (/オンデマンド/.test(productTitle)) {
        printMethod = 'オンデマンド';
      }
    }

    // 色タイプ（productGroupInfoを優先、なければタイトルから抽出）
    let colorType = productGroupInfo?.currentColorType || null;
    if (!colorType) {
      if (/フルカラー/.test(productTitle)) {
        colorType = 'フルカラー';
      } else if (/モノクロ/.test(productTitle)) {
        colorType = 'モノクロ';
      }
    }

    // 紙セレクターモード（統合紙/モノクロ統合/通常）
    const paperSelectorMode = window.productData?.paper_selector_mode || null;

    // 用紙情報を取得（FSC名刺などで coverPaper のみセットされている場合も paper に反映）
    const unifiedPaper = priceCalcSelection.unifiedPaper || null;
    const bodyPaper = priceCalcSelection.bodyPaper || selection.bodyPaper || null;
    const coverPaper = priceCalcSelection.coverPaper || null;
    const paper = selection.paper || priceCalcSelection.paper || (coverPaper && !bodyPaper ? coverPaper : null) || null;

    // タブロイドページ数
    const tabloidPage = window.tabloidPageInfo?.currentPage || null;

    // 伝票印刷情報
    const copyType = productGroupInfo?.currentCopyType || null;
    const fixedPaper = productGroupInfo?.fixedPaper || null;
    const fixedColor = productGroupInfo?.fixedColor || null;

    const requestPayload = {
      variantId: variantId,
      quantity: selection.quantity,
      delivery: selection.delivery,
      calculatedPrice: finalPrice, // ★ ポイント適用後の価格
      // 用紙情報
      paper: paper,
      bodyPaper: bodyPaper,
      coverPaper: coverPaper,
      unifiedPaper: unifiedPaper,
      paperSelectorMode: paperSelectorMode,  // ★ 紙セレクターモード
      // 商品情報
      printMethod: printMethod,
      colorType: colorType,
      printColor: printColorForOrder,
      colorTypeSummary: colorTypeSummary,
      productSize: window.currentProductInfo?.size || null,
      productTitle: productTitle,
      pageRange: pageRange,
      pageCount: pageCount,
      tabloidPage: tabloidPage,  // ★ タブロイドページ数
      // 伝票印刷情報
      copyType: copyType,
      fixedPaper: fixedPaper,
      fixedColor: fixedColor,
      properties: optionProperties
    };
    
    
    // Vercel API を呼び出してDraft Order作成
    const response = await fetch(getDraftOrderApiUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestPayload)
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error: ${response.status} ${errorText}`);
    }
    
    const data = await response.json();
    
    if (data.success && data.invoice_url) {
      // Draft Order作成成功 → Invoice URLにリダイレクト
      // ★ ポイント減算は注文完了後にWebhookで実行されます
      window.location.href = data.invoice_url;
    } else {
      throw new Error(data.error || 'Draft Order作成に失敗しました');
    }
    
  } catch (error) {
    console.error('[Cart] Error:', error);
    alert('カートへの追加に失敗しました。\n\nエラー: ' + error.message + '\n\n再度お試しください。');
    
    // ボタンを再度有効化
    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.textContent = '🛒 カートに追加';
    }
    if (mobileAddToCartBtn) {
      mobileAddToCartBtn.disabled = false;
      mobileAddToCartBtn.textContent = '🛒 カートに追加';
    }
  }
}

